import React, { FC } from 'react';
import { useTranslationsContext } from '../../lib/translation';

const redirectUri = window.location.pathname;

type Props = {
  signInUrl: string;
};

const LoginComponent: FC<Props> = ({ signInUrl }) => {
  const translations = useTranslationsContext();
  return (
    <div className="page__content__block">
      <h1>
        <strong>
          {translations.sign_in.header}
        </strong>
      </h1>
      <p className="text--intro" dangerouslySetInnerHTML={{ __html: translations.sign_in.intro }} />
      <div className="button-container links--plain">
        <a
          className="button button--large"
          href={`${signInUrl}?redirectUri=${redirectUri}`}
        >
          {translations.generics.authentication.sign_in}
        </a>
      </div>
    </div>
  );
};

export default LoginComponent;
